import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/site";

export default function BookingCTA() {
  const { scrollToId } = useApp();
  return (
    <section className="relative py-28 md:py-40 overflow-hidden">
      <img src={IMAGES.cta} alt="Paesaggio abruzzese al tramonto" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/55" />
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center text-white">
        <h2 className="font-heading font-light text-4xl md:text-6xl leading-tight">Il tuo prossimo soggiorno inizia da qui.</h2>
        <p className="mt-5 text-lg text-white/85">Scegli la struttura, inserisci le date e verifica le disponibilità in pochi passaggi.</p>
        <button data-testid="booking-cta" onClick={() => scrollToId("booking")} className="mt-9 inline-flex bg-brand-gold text-white hover:bg-brand-brown transition-colors rounded-full px-9 py-4 font-medium">
          Cerca il tuo soggiorno
        </button>
      </div>
    </section>
  );
}
